var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("transition", { attrs: { name: "fade" } }, [
    _vm.isShown
      ? _c("div", { staticClass: "preloader" }, [
          _c("div", { staticClass: "lds-ripple" }, [
            _c("div", { staticClass: "lds-pos" }),
            _vm._v(" "),
            _c("div", { staticClass: "lds-pos" }),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }